import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { circuitsApi, DIFF_LABEL } from '../services/tourismeApi';
import './Tourisme.css';

function imgFor(c) {
  if (c.mainImageUrl) return c.mainImageUrl;
  const seed = c.mainImageSeed || `cb-tour-circuit-${c.id}`;
  return `https://picsum.photos/seed/${seed}/1600/900`;
}

const CircuitDetail = () => {
  const { slug } = useParams();
  const [circuit, setCircuit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    circuitsApi.get(slug)
      .then((data) => { if (!cancelled) { setCircuit(data.circuit); setLoading(false); } })
      .catch((err) => { if (!cancelled) { setError(err.message); setLoading(false); } });
    return () => { cancelled = true; };
  }, [slug]);

  if (loading) {
    return (
      <main className="tour-page">
        <div className="wrap" style={{ padding: 80 }}>
          <p className="tour-muted">Chargement…</p>
        </div>
      </main>
    );
  }
  if (error || !circuit) {
    return (
      <main className="tour-page">
        <div className="wrap" style={{ padding: 80 }}>
          <p className="tour-muted" style={{ marginBottom: 16 }}>Circuit introuvable.</p>
          <Link to="/tourisme" className="tour-pill">← Retour à la liste</Link>
        </div>
      </main>
    );
  }

  return (
    <main className="tour-page">
      <header
        className="tour-hero"
        style={{
          background: `linear-gradient(135deg, rgba(21,17,15,.85) 0%, rgba(21,17,15,.4) 60%, rgba(21,17,15,.2) 100%), url('${imgFor(circuit)}') center / cover`,
          padding: '80px 0',
        }}
      >
        <div className="wrap tour-hero-inner">
          <Link to="/tourisme" style={{ color: 'rgba(250,246,238,.7)', textDecoration: 'none', fontFamily: 'var(--mono)', fontSize: 11, letterSpacing: '.16em', textTransform: 'uppercase' }}>
            ← Tourisme
          </Link>
          <span className="tour-hero-eyebrow" style={{ display: 'block', marginTop: 18 }}>
            Circuit · {DIFF_LABEL[circuit.difficulty]} · {circuit.duration || '—'}
          </span>
          <h1>{circuit.title}</h1>
          {circuit.shortDescription && <p className="lede">{circuit.shortDescription}</p>}
        </div>
      </header>

      <section className="tour-section">
        <div className="wrap" style={{ maxWidth: 880 }}>
          {circuit.description && (
            <p style={{ fontSize: 16, lineHeight: 1.7, color: 'var(--char-700)', marginBottom: 40 }}>
              {circuit.description}
            </p>
          )}

          <div className="tour-section-head" style={{ marginBottom: 16 }}>
            <div>
              <span className="eyebrow">Étapes du parcours</span>
              <h2 style={{ fontSize: 28 }}>{circuit.stops?.length || 0} arrêt{circuit.stops?.length > 1 ? 's' : ''}</h2>
            </div>
          </div>

          <ol style={{
            listStyle: 'none', padding: 0, margin: 0,
            border: '1px solid var(--line)', borderRadius: 14, overflow: 'hidden',
          }}>
            {circuit.stops?.map((st, i) => (
              <li key={i} style={{
                padding: '20px 24px', borderBottom: '1px solid var(--line)',
                display: 'flex', gap: 20, alignItems: 'flex-start',
              }}>
                <div style={{
                  width: 36, height: 36, borderRadius: '50%',
                  background: 'var(--char-900)', color: 'var(--bone)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontFamily: 'var(--serif)', fontSize: 16, flexShrink: 0,
                }}>{i + 1}</div>
                <div>
                  <b style={{ fontWeight: 500, fontSize: 16 }}>{st.title}</b>
                  {st.description && (
                    <p style={{ margin: '6px 0 0', fontSize: 14, lineHeight: 1.55, color: 'var(--char-700)' }}>
                      {st.description}
                    </p>
                  )}
                </div>
              </li>
            ))}
          </ol>

          <Link to="/tourisme" className="tour-pill" style={{ marginTop: 30, display: 'inline-block' }}>
            ← Tous les circuits
          </Link>
        </div>
      </section>
    </main>
  );
};

export default CircuitDetail;
